export const MONITOR_IDLE_MS = 5 * 60 * 1000;
export const MONITOR_HEARTBEAT_MS = 20000;
// The server lease also expires if a tab crashes or loses its connection.
export function startMonitoringSession(send: (remainingMs: number) => Promise<unknown>, changed: (active: boolean) => void, env = { document, window, now: Date.now }) {
  let lastActivity = env.now(), disposed = false, active = false;
  let chain = Promise.resolve();
  const publish = (remaining: number) => { const deadline = env.now() + remaining; chain = chain.then(() => send(Math.max(0, deadline - env.now()))).then(() => {}, () => {}); };
  const refresh = (heartbeat = false) => {
    const remaining = env.document.visibilityState === 'visible' ? Math.max(0, MONITOR_IDLE_MS - (env.now() - lastActivity)) : 0;
    const next = !disposed && remaining > 0;
    if (next !== active) { active = next; changed(active); publish(next ? remaining : 0); }
    else if (next && heartbeat) publish(remaining);
  };
  const activity = (event: Event) => { if (!event.isTrusted || env.document.visibilityState !== 'visible') return; lastActivity = env.now(); refresh(); };
  // Returning to a visible tab alone does not reset the inactivity timeout.
  const visibility = () => refresh();
  const events = ['pointerdown', 'keydown', 'wheel', 'touchstart'];
  for (const name of events) env.document.addEventListener(name, activity, { passive: true });
  env.document.addEventListener('visibilitychange', visibility);
  refresh();
  const timer = env.window.setInterval(() => refresh(true), MONITOR_HEARTBEAT_MS);
  return () => {
    disposed = true; env.window.clearInterval(timer);
    for (const name of events) env.document.removeEventListener(name, activity);
    env.document.removeEventListener('visibilitychange', visibility);
    active = false; changed(false); publish(0);
  };
}
